import React from "react";
import styles from "./styles.m.css";
import PropTypes from "prop-types";

const ProgressBar = ({ bgcolor, progress, image }) => {
  const Parentdiv = {
    height: 100,
    backgroundColor: "white",
    borderRadius: 50
  };

  const Childdiv = {
    height: "100%",
    width: `${progress}%`,
    backgroundColor: bgcolor,
    borderRadius: 50,
    textAlign: "right"
  };

  const progresstext = {
    padding: 10,
    color: bgcolor,
    fontWeight: 900
  };

  return (
    <div style={Parentdiv} className={styles["progress-wrapper"]}>
      <div style={Childdiv} className={styles["progress"]}>
        <img src={image} alt="" className={styles["progress-image"]} />
        <span style={progresstext} className={styles["progress-text"]}>{`${progress}%`}</span>
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  bgcolor: PropTypes.string,
  progress: PropTypes.number,
  image: PropTypes.string
};

export class GurupeyarchiStaticPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      zodiacs: [
        {
          title: "மேஷம்",
          titleshort: "மேஷ",
          score: 73,
          slogan: "சிக்கனம் கடைபிடித்தால் சிறப்பாக வாழலாம்",
          image: "https://media.vikatan.com/vikatan/2021-07/3c73071b-24f1-4201-aa7a-d5afe3527717/01_mesham.png",
          color: "#359a0b"
        },
        {
          title: "ரிஷபம்",
          titleshort: "ரிஷப",
          score: 95,
          slogan: "அதிரடி முன்னேற்றம் - அற்புத யோகம்",
          image: "https://media.vikatan.com/vikatan/2021-07/52fe7d74-49d6-4c40-90c6-3a6922664a40/02_rishabam.png",
          color: "#359a0b"
        },
        {
          title: "மிதுனம்",
          titleshort: "மிதுன",
          score: 64,
          slogan: "கடின உழைப்பால் உயர வேண்டிய காலம்",
          image: "https://media.vikatan.com/vikatan/2021-07/ee73ab5b-e1c7-4f25-90d9-a8735dabbc95/03_medhunam.png",
          color: "#f58426"
        },
        {
          title: "கடகம்",
          titleshort: "கடக",
          score: 70,
          slogan: "குறைவில்லா வாழ்வு தரப்போகும் குருபார்வை",
          image: "https://media.vikatan.com/vikatan/2021-07/01506f0b-f8ec-4e4c-aef9-3688846ba70a/04_kadakam.png",
          color: "#f58426"
        },
        {
          title: "சிம்மம்",
          titleshort: "சிம்ம",
          score: 60,
          slogan: "கொஞ்சம் அலைச்சல் - கொஞ்சம் டென்ஷன் - நிறைய வெற்றி!",
          image: "https://media.vikatan.com/vikatan/2021-07/f3d97800-471c-43fe-aa50-dd8bdf4515e6/05_simmam.png",
          color: "#f58426"
        },
        {
          title: "கன்னி",
          titleshort: "கன்னி",
          score: 73,
          slogan: "ஆசைகள் நிறைவேறும். மதிப்பு மரியாதை கூடும்",
          image: "https://media.vikatan.com/vikatan/2021-07/f1902ca8-4b3b-4616-a5b2-25b4813fe237/06_kanni.png",
          color: "#359a0b"
        },
        {
          title: "துலாம்",
          titleshort: "துலாம்",
          score: 55,
          slogan: "சிந்தித்துச் செயல்பட்டால் வானம் வசப்படும்",
          image: "https://media.vikatan.com/vikatan/2021-07/59864243-1ce8-4ea5-b7e3-3baf1f432092/07_dulam.png",
          color: "#f90425"
        },
        {
          title: "விருச்சிகம்",
          titleshort: "விருச்சிக",
          score: 90,
          slogan: "நினைத்தது நிறைவேறும். புதிய வலிமை பிறக்கும்",
          image: "https://media.vikatan.com/vikatan/2021-07/1ea78197-ce9e-4972-be02-024a67d85b02/08_viruchagam.png",
          color: "#359a0b"
        },
        {
          title: "தனுசு",
          titleshort: "தனுசு",
          score: 51,
          slogan: "பக்குவம் பிறக்கும். திறமைகள் வெளிப்படும்",
          image: "https://media.vikatan.com/vikatan/2021-07/1f34b79e-3968-4261-8cec-5b54d7a8a370/09_thausu.png",
          color: "#f90425"
        },
        {
          title: "மகரம்",
          titleshort: "மகர",
          score: 61,
          slogan: "துணிச்சல் அதிகரிக்கும். வெற்றிப்பாதையில் நடைபோடுவீர்கள்",
          image: "https://media.vikatan.com/vikatan/2021-07/a26c71ac-4b59-4eb4-b543-1070fd289300/10_magaram.png",
          color: "#f58426"
        },
        {
          title: "கும்பம்",
          titleshort: "கும்ப",
          score: 66,
          slogan: "புதிய முயற்சிகள் வெற்றியாகும். பணவரவு மேம்படும்.",
          image: "https://media.vikatan.com/vikatan/2021-07/30b4c36f-e326-4d54-aa96-5a72a3bbd449/11_kumbam.png",
          color: "#f58426"
        },
        {
          title: "மீனம்",
          titleshort: "மீன",
          score: 54,
          slogan: "வளைந்துகொடுத்துப் போக வாழ்க்கை சிறக்கும்",
          image: "https://media.vikatan.com/vikatan/2021-07/aaf1130d-bfa5-498d-9557-d9317bd5aa3b/12_meenam.png",
          color: "#f90425"
        }
      ],
      CurrentIndex: 0
    };
    this.outerarticle = React.createRef();
  }

  setView = (action = false) => {
    if (action === true) {
      window.scrollTo({
        top: this.outerarticle.current.offsetTop + this.outerarticle.current.offsetHeight - 100,
        behavior: "smooth"
      });
    }
  };

  render() {
    return (
      <div className={`${styles["gurupayrchi-wrapper"]} container`}>
        <div className={styles["raasipalan-wrapper"]}>
          <div className={styles["banner-img"]}>
            <img
              src="https://media.vikatan.com/vikatan/2022-03/1a78b80b-847a-46b5-af55-d9b89058d59f/gurupeyarchi22_23_web.png"
              alt=""
              className={styles["image"]}
            />
            <h1>
              உங்கள் ராசிக்கு குருப்பெயர்ச்சிப் பலன் எப்படி?
              <span>ஸ்கோரை அறிய ராசியை க்ளிக் செய்யுங்கள்!</span>
            </h1>
          </div>
          <ul className={styles["raasi-grid"]} ref={this.outerarticle}>
            {this.state.zodiacs.map((zodiac, index) => (
              <li
                key={index}
                onClick={() => {
                  this.setState({
                    CurrentIndex: index
                  });
                  this.setView(true);
                }}
              >
                <img src={zodiac.image} alt="" />
                <div className={styles["rassi-content"]}>
                  <h4 className={`${index === this.state.CurrentIndex ? styles["active"] : ""}`}>{zodiac.title}</h4>
                </div>
              </li>
            ))}
          </ul>
          <div className={styles["raasi-score-wrapper"]}>
            <h1>
              <span className={styles["zodiac-short"]}>
                {this.state.zodiacs[this.state.CurrentIndex].titleshort} ராசிக்காரர்களே... !
              </span>
              <span className={styles["desc"]}>{this.state.zodiacs[this.state.CurrentIndex].slogan}</span>
            </h1>
            <ProgressBar
              bgcolor={this.state.zodiacs[this.state.CurrentIndex].color}
              progress={this.state.zodiacs[this.state.CurrentIndex].score}
              image={this.state.zodiacs[this.state.CurrentIndex].image}
            />
          </div>
          <h5 className={styles["other-text"]}>
            உங்களுக்கும், உங்கள் குடும்பத்தினருக்கும் முழுமையான குருப்பெயர்ச்சிப் பலன்களைத் தெரிந்துகொள்ள :
          </h5>

          <a
            className={styles["navigation"]}
            href="https://www.vikatan.com/collection/gurupeyarchi-palangal-and-remedies-2022-23?utm_source=web&utm_medium=menu&utm_campaign=gurupeyarchi"
            onClick={() => {
              if ("ga" in window) {
                window.ga("send", "event", "gurupeyarchi22-23-web", "click", window.location.href);
              }
              if ("gtag" in window) {
                window.gtag("event", "gurupeyarchi22-23-we", {
                  event_category: "click",
                  event_label: window.location.href
                });
              }
            }}
          >
            12 ராசிகளுக்குமான முழுப்பலன்களைக் காண
          </a>
        </div>
      </div>
    );
  }
}

export default GurupeyarchiStaticPage;
